var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryBox02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4653 1L2.53467 1C2.03431 1 1.78413 1 1.61091 1.11817C1.52512 1.1767 1.45422 1.25406 1.40378 1.34418C1.30194 1.52614 1.32683 1.77195 1.37662 2.26358C1.45972 3.08416 1.50127 3.49445 1.71882 3.78779C1.82723 3.93397 1.96467 4.05679 2.12276 4.14877C2.44 4.33333 2.85757 4.33333 3.69272 4.33333L12.3073 4.33333C13.1424 4.33333 13.56 4.33333 13.8772 4.14877C14.0353 4.05679 14.1728 3.93397 14.2812 3.78779C14.4987 3.49445 14.5403 3.08416 14.6234 2.26358C14.6732 1.77195 14.6981 1.52614 14.5962 1.34418C14.5458 1.25406 14.4749 1.1767 14.3891 1.11817C14.2159 1 13.9657 1 13.4653 1Z",
    stroke: "#DB6E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2 4.33398L2 7.69453C2 10.1959 2 11.4465 2.78105 12.2236C3.5621 13.0006 4.81918 13.0007 7.33333 13.0007H8.66667C11.1808 13.0007 12.4379 13.0006 13.219 12.2236C14 11.4465 14 10.1959 14 7.69453V4.33398",
    stroke: "#DB6E00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.66667 6.33398L9.33333 6.33398",
    stroke: "#DB6E00",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryBox02);
export default __webpack_public_path__ + "static/media/delivery-box-02.4155394c1b9d74a04babcb585e93c2f0.svg";
export { ForwardRef as ReactComponent };